import { createAction } from "@reduxjs/toolkit";
import api from "../../services/api";


export const addNotification = createAction("ADD_NOTIFICATIONS");
export const clearNotifications = createAction("CLEAR_NOTIFICATIONS");
export const clearOneNotification = createAction("CLEAR_ONE_NOTIFICATION");


export const handleMarkAllNotifications = (type) => {
    return (dispatch) =>
        api
            .put("/notifications/read", {
                type,
            })
            .then((res) => dispatch(clearNotifications()))
            .catch((err) => Promise.reject(err));
};


export const handleMarkOneNotification = (notificationId) => {
    return (dispatch) =>
        api
            .put(`/notifications/${notificationId}/read`)
            .then((res) => dispatch(clearOneNotification(res.data)))
            .catch((err) => Promise.reject(err));
};